<template>

  <div class="uk-grid_ area-riservata__main-content--table">
    <table class="rwd-table table-shadow">
      <colgroup>
        <col span="1" style="width: 10%;">
        <col span="1" style="width: 10%;">
        <col span="1" style="width: 10%;">
        <col span="1" style="width: 10%;">
        <col span="1" style="width: 10%;">
        <col span="1" style="width: 10%;">
        <col span="1" style="width: 8%;">
        <col span="1" style="width: 8%;">
      </colgroup>
      <tbody>
        <tr>
          <th>{{ $t('frontend-mtg.area_riservata.table.th_1') }}</th>
          <th>{{ $t('frontend-mtg.area_riservata.table.th_2') }}</th>
          <th>{{ $t('frontend-mtg.area_riservata.table.th_3') }}</th>
          <th>{{ $t('frontend-mtg.area_riservata.table.th_4') }}</th>
          <th>{{ $t('frontend-mtg.area_riservata.table.th_5') }}</th>
          <th>{{ $t('frontend-mtg.area_riservata.table.th_6') }}</th>
          <th>{{ $t('frontend-mtg.area_riservata.table.th_7') }}</th>
          <th></th>
        </tr>

        <tr v-for="item in items">
          <td :data-th="$t('frontend-mtg.area_riservata.table.th_1')">
            <span class="td-content">{{ item.order_year }}</span>
          </td>
          <td :data-th="$t('frontend-mtg.area_riservata.table.th_2')">
            <span class="td-content">{{ item.code }}</span>
          </td>
          <td :data-th="$t('frontend-mtg.area_riservata.table.th_3')">
            <span class="td-content">{{ item.code_reference }}</span>
          </td>
          <td :data-th="$t('frontend-mtg.area_riservata.table.th_4')">
            <span class="td-content">{{ item.order_confirmation_date }}</span>
          </td>
          <td :data-th="$t('frontend-mtg.area_riservata.table.th_5')">
            <span class="td-content">{{ item.code_incoterms }}</span>
          </td>

          <td :data-th="$t('frontend-mtg.area_riservata.table.th_6')">
            <span class="td-content">
                <span class="price-label">{{ item.total }} <small>{{ item.code_iso }}</small></span>
            </span>
          </td>

          <td :data-th="$t('frontend-mtg.area_riservata.table.th_7')">
            <span class="td-content">
                <span :class="item.process_status_color + ' stato'" :uk-tooltip="'title: ' + $t('frontend-mtg.area_riservata.ordini.' + item.process_status_tag)"></span>
            </span>
          </td>
          <td class="has-cta ">

            <span class="td-content td-flex">
                <a :href="item.url" class="rwd-table__cta">
                  <em class="uk-hidden@m">{{ $t('frontend-mtg.area_riservata.ordini.vai_dettaglio') }}</em>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 188.7 306" xml:space="preserve" fill="#000" class="icon">
                    <path d="M35.7 0 0 35.7 117.3 153 0 270.3 35.7 306l153-153z"></path>
                  </svg>
                </a>
                <label class="checkbox-wrapper">
                  <input type="checkbox" name="order" :value="item.id">
                  <span class="shape"></span>
                </label>
            </span>

          </td>

        </tr>

      </tbody>
    </table>
  </div>
  

</template>

<script>
import DataGridResults from 'js/theme-mixins/DataGridResults';

export default {
  mixins: [DataGridResults],
  computed: {
    itemNumber() {
      return this.items.length
    }
  },
  watch: {
    // items() {
    //   this.$nextTick(function () {
    //     document.querySelectorAll(".professional-card-image").forEach(img => {
    //       img.classList.add("lazyload");
    //     })
    //   })
    // }
  },
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/OrdersDataGridResults.vue